// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yBca","colBig":"styles_colBig__vJYOM","colSmall":"styles_colSmall__1xPBS","shopifyNameWrapper":"styles_shopifyNameWrapper__3wsxk"};